import React from 'react';

import '../styles/RecordingTips.css';


const RecordingTips = ({show, recording, duration, cancelling, clickMode, onCancelRecord, onWebCancelRecord}) => {
	const secondsRemainded = 60 - duration;
	if(!show)
		return null;

	const GetIcon = () => {
		if(cancelling){
			return <i className="iconfont icon-cuowu mic-font"></i>;
		}
		if(!recording){
			return <i className="iconfont icon-gengduo1 mic-font"></i>;
		}
		if(secondsRemainded >= 10){
			return <i className="iconfont icon-xinbanketangye-maikefeng mic-font"></i>;
		}
		return <span className="countdown">{secondsRemainded}</span>;
	};

	return (<div className="recording-tips">
			<div className="title">{recording?'录音中... ' + duration : '准备中...'}</div>
			<div className="icon">
				{GetIcon()}
			</div>
			{window.platform === 'weixin' ?
				(clickMode && !cancelling ?
					<div className="cancel" onClick={clickMode ? onCancelRecord : null}>点击此处，取消发送</div>
					:
					<div className={'cancel ' + (cancelling?'cancelling':'')}>上滑手指，取消发送</div>)
				:
				<div className="cancel" onClick={onWebCancelRecord}>点击此处，取消发送</div>

            }
		</div>)
};


export default RecordingTips;



// WEBPACK FOOTER //
// ./src/components/RecordingTips.js